// import Swiper JS
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

// import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';


// main gallery slider
const gallerySwiper = new Swiper(".gallerySwiper", {
    modules: [Navigation],
    loop: true,
    spaceBetween: 20,
    slidesPerView: 2,
    centeredSlides: true,
    slideToClickedSlide: false,
    a11y: false,
    //watchSlidesProgress: true,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },


    /*
    controller: {
        control: thumbSwiper,
    },
    */

    breakpoints: {
        640: {
            slidesPerView: 2,
        },
        768: {
            slidesPerView: 2,
        },
        992: {
            slidesPerView: 3,
        },
        1200: {
            slidesPerView: "auto",
        },
    },
});


// workbook slider
const workbookSwiper = new Swiper(".workbookSwiper", {
    modules: [Navigation],
    loop: true,
    spaceBetween: 40,
    slidesPerView: 2.5,
    centeredSlides: true,
    slideToClickedSlide: false,
    a11y: false,
    //updateOnWindowResize: true,
    //watchSlidesProgress: true,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },

    breakpoints: {

        1200: {
            slidesPerView: 5,
            centeredSlides: false,
            spaceBetween: 20,
        },

    },

});
